import React from "react";
import { Container, Content } from "./styles";
import useCurrentDevice from "../../utils/useCurrentDevice";
import { Devices } from "../../consts/devices";
import NewsTileItem from "./NewsTileItem";

const NewsTiles = ({ NewsTilesList = [], background, fontColor }) => {
  const currentDevice = useCurrentDevice();
  const isMobile = [Devices.MOBILE, Devices.TABLET].includes(currentDevice);

  const generateNewsTileItems = ({ linkUrl, label, image, date }, index) => (
    <NewsTileItem
      key={`${label}-${index}`}
      index={index}
      linkUrl={linkUrl}
      label={label}
      image={image}
      date={date}
      isMobile={isMobile}
    />
  );

  return (
    <Container background={background} font_color={fontColor}>
      <Content>
        {NewsTilesList.map((item, index) => generateNewsTileItems(item, index))}
      </Content>
    </Container>
  );
};

export default NewsTiles;
